<template>
  <j-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ height: '500px', overflow: 'hidden', overflowY: 'scroll' }"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('名称')" prop="name">
                <a-input v-model="model.name" :placeholder="$t('请输入名称')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('备注')" prop="remark">
                <a-input v-model="model.remark" :placeholder="$t('请输入备注')"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-table
                ref="table"
                size="middle"
                :scroll="{ x: 800 }"
                bordered
                rowKey="id"
                :columns="columns"
                :dataSource="model.customizeConfigDataList"
                :pagination="false"
                class="j-table-force-nowrap"
              >
                <template slot-scope="text, record" slot="icon">
                  <j-image-upload
                    class="avatar-uploader"
                    :text="$t('上传')"
                    :isMultiple="false"
                    v-model="record.icon"
                  ></j-image-upload>
                </template>
              </a-table>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import JImageUpload from './JImageUpload.vue'
export default {
  name: 'modal',
  components: {
    JImageUpload
  },
  data() {
    return {
      title: this.$t('图标配置'),
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      url: {
        createCustomizeConfigScheme: '/jeecg-gis/customizeConfigScheme/createCustomizeConfigScheme',
        editCustomizeConfigScheme: '/jeecg-gis/customizeConfigScheme/editCustomizeConfigScheme',
      },
    }
  },
  computed: {
    validatorRules() {
      return {
        name: [{ required: true, message: this.$t('请输入名称') }],
        remark: [{ required: true, message: this.$t('请输入备注') }],
      }
    },
    columns() {
      return [
        {
          title: this.$t('类型'),
          dataIndex: 'nodeType',
          key: 'nodeType',
          align: 'center',
          customRender: (t, r, index) => filterDictTextByCache('node_type', t),
        },
        {
          title: this.$t('图标'),
          dataIndex: 'icon',
          key: 'icon',
          align: 'center',
          scopedSlots: { customRender: 'icon' },
        },
      ]
    },
  },
  methods: {
    edit(row) {
      this.visible = true
      console.log("编辑返回", row)
      if (row.customizeConfigScheme.id) {
        this.model = Object.assign({}, row, {
          name: row.customizeConfigScheme.name,
          remark: row.customizeConfigScheme.remark,
        })
      } else {
        this.model = Object.assign({}, row, {
          customizeConfigDataList: [
            {
              nodeType: 'NODE_PIPELINE_TYPE_VALVE',
              icon: '',
            },
            {
              nodeType: 'NODE_PIPELINE_TYPE_HYDRANT',
              icon: '',
            },
            {
              nodeType: 'NODE_PIPELINE_TYPE_TOWER',
              icon: '',
            },
            {
              nodeType: 'NODE_PIPELINE_TYPE_BOOSTER_PUMP_STATION',
              icon: '',
            },
            {
              nodeType: 'NODE_PIPELINE_TYPE_METER',
              icon: '',
            },
            {
              nodeType: 'NODE_PIPELINE_TYPE_COMMON',
              icon: '',
            },
            {
              nodeType: 'NODE_PIPELINE_TYPE_EV',
              icon: '',
            },
            {
              nodeType: 'NODE_PIPELINE_TYPE_WQ',
              icon: '',
            },
            {
              nodeType: 'NODE_PIPELINE_TYPE_PM',
              icon: '',
            },
            {
              nodeType: 'NODE_PIPELINE_TYPE_WM',
              icon: '',
            },
            {
              nodeType: 'NODE_PIPELINE_TYPE_FM',
              icon: '',
            },
          ],
        })
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    handleOk() {
      const that = this
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          let url = ''
          let message = ''
          let params = {
            customizeConfigScheme: {},
            customizeConfigDataList: this.model.customizeConfigDataList,
          }
          if (this.model.customizeConfigScheme.id) {
            url = this.url.editCustomizeConfigScheme
            message = this.$t('编辑成功！')
            params.customizeConfigScheme = {
              id: this.model.customizeConfigScheme.id,
              projectCode: this.model.customizeConfigScheme.projectCode,
              name: this.model.name,
              remark: this.model.remark,
              customizeType: this.model.customizeConfigScheme.customizeType,
            }
          } else {
            url = this.url.createCustomizeConfigScheme
            message = this.$t('新增成功！')
            params.customizeConfigScheme = {
              projectCode: this.model.customizeConfigScheme.projectCode,
              name: this.model.name,
              remark: this.model.remark,
              customizeType: this.model.customizeConfigScheme.customizeType,
            }
          }
          postAction(url, params)
            .then(res => {
              if (res.success) {
                that.$message.success(message)
                that.$emit('ok', this.model)
                this.visible = false
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
  },
}
</script>
